import classes from './AdminSidebar.module.css';
import SidebarItem from '../SidebarItem/SidebarItem';
import { Link, useLocation } from 'react-router';
/*import {
	ChevronRightRounded,
	KeyboardArrowDownRounded
} from '@material-ui/icons';*/

const AdminSidebar = ({ pages, setPage, currentPage }) => {
	const location = useLocation()
	return (
		<div className={`${classes.Sidebar} flex-1 min-h-screen h-full bg-slate-100`} style={{ backgroundColor: '#405189' }}>
			<div>
				<div className="mb-3 p-5 ">
					{/* <h3>Dashboard</h3> */}
					<ul>
						{pages.map((page) => {
							console.log(page.id, currentPage);
							// const activeIcon= page.id === currentPage? <KeyboardArrowDownRounded /> : <ChevronRightRounded />;
							return (
								// <SidebarItem
								// 	key={page.title}
								// 	label={page.title}
								// 	icon={page.icon}
								// 	onClick={() => setPage(page.id)}
								// 	active={currentPage === page.id}

								// />
<li className=' bg-inherit w-full h-max px-4 py-2 lg:p-4 text-white text-left hover:scale-110 hover:px-6  '>

<Link to={`/admin/${page.url}`}
 className={`${location.pathname.includes(page.url)?"shadow shadow-white":""} bg-inherit w-full h-max px-4 py-2 lg:p-4 text-white text-left hover:scale-110 hover:px-6 `}
  >
{page.title}
</Link>
</li>

							);
						})}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default AdminSidebar;
